import { render, staticRenderFns } from "./scm.vue?vue&type=template&id=2c81dd49&scoped=true&"
import script from "./scm.vue?vue&type=script&lang=js&"
export * from "./scm.vue?vue&type=script&lang=js&"
import style0 from "./scm.vue?vue&type=style&index=0&id=2c81dd49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81dd49",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QCardSection}, component.options.components || {})
